import { render, staticRenderFns } from "./BoardViewV2Page.vue?vue&type=template&id=1675bcb0&scoped=true&"
import script from "./BoardViewV2Page.vue?vue&type=script&lang=js&"
export * from "./BoardViewV2Page.vue?vue&type=script&lang=js&"
import style0 from "./BoardViewV2Page.vue?vue&type=style&index=0&id=1675bcb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1675bcb0",
  null
  
)

export default component.exports